import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { io } from 'socket.io-client';

const baseUrl = process.env.REACT_APP_BASE_CONNECTION!;
const socket = io(baseUrl, {
  path: '/v1/socket.io' // Ensure the correct path is set for Socket.IO
});
console.log(baseUrl);
const SocketHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Listen for user ID events
    socket.on('userIdEvent', (userId) => {
      console.log(`message from server: ${userId}`);
      handleUserIdEvent(userId);
    });

    // Cleanup listener on component unmount
    return () => {
      socket.off('userIdEvent');
    };
  }, []);

  const handleUserIdEvent = (userId: string) => {
    const currentUserId = localStorage.getItem('userId');
    if (currentUserId && userId === currentUserId) {
      console.log(`User logged out due to socket event: ${userId}`);
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("resume");
      localStorage.removeItem("scope");
      navigate("/login");
    }
  };

  return null; // This component doesn't render anything
};

export default SocketHandler;
